module.exports = __webpack_public_path__ + "img/agency_banner_1.a2ab767c.png";